export default "__VITE_ASSET__ucru5btW__"